<template>
  <div
    :style="{
      backgroundImage: 'url(' + bg + ')',
      backgroundPosition: 'center',
    }"
  >
    <dashboard-header class="white"></dashboard-header>

    <v-container>
      <v-card>
        <v-container>
          <v-layout>
            <v-flex>
              <div class="display-3 mb-3">
                <strong>Mandatory Assessment</strong>
              </div>
              <!--<p class="title grey--text text--lighten-1">
                The following set of questions will assess your understanding of the module. You need to get <strong class="accent--text text--lighten-3">{{ module.minimum_score }} out of {{ questionsLength }}</strong> questions correctly to earn CPD points.
              </p>-->
              <p class="title grey--text text--lighten-1">
                You need to answer each question correctly before you can
                proceed to the next item. You can earn the CPD units once you
                have completed the entire course.
              </p>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <v-form>
                <v-stepper v-model="e1">
                  <v-stepper-header>
                    <template v-for="n in steps">
                      <v-stepper-step
                        :key="`${n}-step`"
                        :step="n"
                        :complete="e1 > n"
                        :rules="[() => validAnswer !== n]"
                      >
                        <small v-if="validAnswer === n">Invalid answer</small>
                      </v-stepper-step>
                      <v-divider v-if="n !== steps" :key="n"></v-divider>
                    </template>
                  </v-stepper-header>

                  <v-stepper-items>
                    <v-stepper-content
                      v-for="(question, q) in selectedQuestions"
                      :step="q + 1"
                      :key="`${q}-content`"
                    >
                      <v-container>
                        <v-layout wrap>
                          <v-flex xs12>
                            <p>
                              <strong>Question {{ q + 1 }}</strong>
                            </p>
                            <p v-html="question.question"></p>
                          </v-flex>

                          <v-radio-group v-model="radioGroup[q]">
                            <v-layout wrap>
                              <v-flex
                                v-for="(choice, c) in question.choices"
                                :key="c"
                                xs12
                              >
                                <v-radio
                                  :label="choice.label"
                                  :value="choice"
                                ></v-radio>
                              </v-flex>
                            </v-layout>
                          </v-radio-group>
                        </v-layout>
                        <v-layout>
                          <v-flex>
                            <v-btn color="primary" @click="nextStep(q + 1, q)">
                              <div v-if="q + 1 < steps">Next</div>
                              <div v-else>Submit</div>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-container>

    <v-footer height="112">
      <main-footer></main-footer>
    </v-footer>

    <v-dialog v-model="dialog" max-width="1000" persistent>
      <assessment-result
        :score="score"
        :minimum="parseNumber(module.minimum_score)"
        :total="steps"
        :points="points"
        :retry="retry"
        :reviewModule="reviewModule"
        :certificateCode="certificateCode"
        :completion="completion"
        :totalModule="totalModule"
      ></assessment-result>
    </v-dialog>
  </div>
</template>

<script>
import DashboardHeader from "@/components/dashboard/dashboardHeader";
import MainFooter from "@/components/mainFooter";
import AssessmentResult from "@/components/module/assessment/assessmentResult";

import axios from "axios";
import { getUser } from "@/utils/token";
import config from "../../../../configApi";
const apiUrl = config.apiUrl;

export default {
  components: {
    DashboardHeader,
    MainFooter,
    AssessmentResult,
  },
  created() {
    this.fetchData();
  },
  computed: {
    questionsLength() {
      return this.selectedQuestions.length;
    },
    selectedQuestions() {
      return this.shuffle(this.questions).slice(0, 5);
    },
  },
  data() {
    return {
      e1: 1,
      bg: require("@/assets/bg/water_4.png"),
      dialog: false,
      certificateCode: "",
      radioGroup: [],
      user: getUser(),
      moduleId: this.$route.params.id,
      module: {},
      questions: this.serverData.questions,
      steps: this.serverData.questions.length,
      score: 0,
      minimum: 2,
      points: 0,
      completion: 0,
      totalModule: 0,
      validAnswer: 0,
    };
  },
  methods: {
    shuffle(array) {
      var currentIndex = array.length;
      var temporaryValue;
      var randomIndex;

      // While there remain elements to shuffle...
      while (currentIndex !== 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array;
    },
    getValue(id) {
      return String(id);
    },
    retry() {
      this.$set(this, "dialog", false);
      this.e1 = 1;
    },
    reviewModule() {
      this.$set(this, "dialog", false);
      this.$router.push("/module/" + this.moduleId);
    },
    nextStep(n, activeKey) {
      this.score =
        Number(this.score) + Number(this.radioGroup[activeKey].value);

      if (n === this.steps) {
        if (this.score >= this.module.minimum_score) {
          this.points = this.module.cpd_points;
        }
        this.onSubmit();
        // this.dialog = true
      } else {
        if (this.radioGroup[activeKey].value === "1") {
          this.e1 = n + 1;
          this.validAnswer = 0;
        } else {
          this.validAnswer = n;
        }
      }
    },
    onSubmit() {
      let self = this;
      let data = {
        user_id: this.user.id,
        module_id: this.$route.params.id,
        score: this.score,
      };
      axios
        .post(apiUrl + "/assessment", data)
        .then((r) => {
          self.certificateCode = r.data.certificate
            ? String(r.data.certificate.code)
            : "";
          self.totalModule = r.data.module_count;
          self.completion = r.data.completion;
          self.setSessionUser();
          self.dialog = true;
        })
        .catch((e) => {});
    },
    getChoices(questionId) {
      return this.questions.filter(function (v) {
        return v.id === questionId;
      }).choices;
    },
    fetchData() {
      this.getModule();
    },
    getModule() {
      if (navigator.onLine) {
        console.log("User is online - Fetching info from server");
        axios
          .get(apiUrl + "/module/" + this.moduleId)
          .then((e) => {
            // console.log(e.data)
            this.$set(this, "module", e.data);
          })
          .catch((e) => {
            console.log("error", e);
          });
      } else {
        console.log("User is offline - Fetching info from localstorage");
      }
    },
    setSessionUser() {
      axios
        .get(`${apiUrl}/user`)
        .then((res) => {
          localStorage.setItem("user", JSON.stringify(res.data));
          sessionStorage.setItem("user", JSON.stringify(res.data));
          // this.$router.push('/dashboard')
        })
        .catch((error) => {
          console.log(error);
        });
    },
    parseNumber(str) {
      return Number(str);
    },
  },
  props: {
    serverData: {
      default() {
        return [];
      },
    },
  },
  watch: {
    dialog(v) {
      if (v === false) {
        this.score = 0;
        this.e1 = 1;
        this.radioGroup = [];
      }
    },
    module(v) {
      this.questions = v.questionnaire;
    },
    selectedQuestions(v) {
      this.$set(this, "steps", v.length);
    },
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/module/assessment/index.vue